import TWEEN from '@tweenjs/tween.js';
import {animateFrame} from './TweenUtil';

export function startStayReward(box, game, points, label, onAward = () => {}) {
  if (box.bonusAwarded || box.stayTween) return;
  box.stayTween = new TWEEN.Tween({t: 0}).to({t: 1}, 3000)
    .onComplete(() => {
      box.stayTween = null;
      if (game.state !== 'playing' || game.littleMan.box !== box) return;
      box.bonusAwarded = true;
      onAward();
      game.onPlatformBonus(points, label);
    }).start();
  animateFrame();
}

export function cancelStayReward(box) {
  if (box.stayTween) box.stayTween.stop();
  box.stayTween = null;
}
